"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var dates = _interopRequireWildcard(require("@simplybenefits/sb-dates"));
var _react = _interopRequireWildcard(require("react"));
var _Text = _interopRequireDefault(require("../../../components/Text"));
var _theme = require("../../../theme");
var _sbUtils = require("@simplybenefits/sb-utils");
var _zIndex = _interopRequireDefault(require("../../../theme/zIndex"));
var _MoreVert = _interopRequireDefault(require("@mui/icons-material/MoreVert"));
var _Menu = _interopRequireDefault(require("@mui/material/Menu"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _TerminationModal = _interopRequireDefault(require("./TerminationModal"));
var Services = _interopRequireWildcard(require("../../../services"));
var _i18n = _interopRequireDefault(require("../../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var PurchasedProducts = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(PurchasedProducts, _PureComponent);
  function PurchasedProducts() {
    var _this;
    (0, _classCallCheck2["default"])(this, PurchasedProducts);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, PurchasedProducts, [].concat(args)), _this.state = {
      anchorEl: null,
      productToTerminate: null,
      showTerminationModal: false,
      total: 0
    }, _this._handleMenuClick = function (event, productID, parentProductID, entity) {
      _this.setState({
        anchorEl: event.currentTarget,
        productToTerminate: {
          productID: productID,
          parentProductID: parentProductID
        }
      });
    }, _this._handleCloseMenu = function () {
      _this.setState({
        anchorEl: null
      });
    }, _this._openTerminationModal = function () {
      _this.setState({
        showTerminationModal: true,
        anchorEl: null
      });
    }, _this._closeTerminationModal = function () {
      _this.setState({
        showTerminationModal: false,
        productToTerminate: null
      });
    }, _this._terminateProduct = /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(signage, password) {
        var success;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.props.terminateProduct(_this.state.productToTerminate.productID, _objectSpread(_objectSpread({}, signage), {}, {
                datedOn: Services.dates.formatOutgoingDate(signage.datedOn)
              }), password);
            case 2:
              success = _context.sent;
              if (success) {
                _this._closeTerminationModal();
              }
              return _context.abrupt("return", false);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }(), _this._getTotal = function () {
      var total = 0;

      // eslint-disable-next-line array-callback-return
      Object.keys(_this.props.purchasedProducts).map(function (productID) {
        var product = _this.props.purchasedProducts[productID];
        total += product.primary.premium + product.primary.PST + (product.primary.RST || 0) + product.primary.GST + product.primary.HST;
        total += product.dependent ? product.dependent.premium + product.dependent.PST + (product.dependent.RST || 0) + product.dependent.GST + product.dependent.HST : 0;
        total += product.spouse ? product.spouse.premium + product.spouse.PST + (product.spouse.RST || 0) + product.spouse.GST + product.spouse.HST : 0;
        total += product.child ? product.child.premium + product.child.PST + product.child.RST + product.child.GST + product.child.HST : 0;
      });
      return total;
    }, _this._renderRow = function (styles, product, member) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.blockContent
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        large: true,
        bold: true,
        color: _this.props.whitelabel.primaryColor || _theme.colors.skyBlue,
        customStyle: {
          flex: 4
        }
      }, "".concat(product.meta.type.toUpperCase() === 'VOLUNTARY' ? _i18n["default"].t(_tokens["default"].labels.marketplace.voluntary) : _i18n["default"].t(_tokens["default"].labels.marketplace.optional), " ").concat(product.meta.name.primary[_this.props.member.language])), product.meta.enBrochure && _this.props.member.language === 'en' && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        tiny: true,
        color: _this.props.whitelabel.primaryColor || _theme.colors.skyBlue,
        onClick: function onClick() {
          return window.open(product.meta.enBrochure, "_blank");
        },
        customStyle: {
          cursor: 'pointer',
          marginLeft: 2,
          marginTop: -5
        }
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.downloadBrochure)), product.meta.frBrochure && _this.props.member.language === 'fr' && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        tiny: true,
        color: _this.props.whitelabel.primaryColor || _theme.colors.skyBlue,
        onClick: function onClick() {
          return window.open(product.meta.frBrochure, "_blank");
        },
        customStyle: {
          cursor: 'pointer',
          marginLeft: 2,
          marginTop: -5
        }
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.downloadBrochure)), product.primary.active && /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.blockRow
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          flex: 3,
          paddingLeft: 10
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        mediumLarge: true
      }, "".concat(member.firstname, " ").concat(member.lastname)), product.primary.termDate && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        tiny: true,
        color: "red"
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.terminateOnDate, {
        termDate: dates.formatDateForDisplay(product.primary.termDate, "ll", _i18n["default"].locale)
      }))), product.meta.policyNumbers ? /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          flex: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.inline
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        align: "center",
        margin: "0 5px 0 0"
      }, _i18n["default"].t(_tokens["default"].labels.claimSummary.primary), ":"), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        bold: true,
        align: "center"
      }, product.meta.primaryPolicyNumber || '-')), product.meta.policyNumbers.secondary && /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.inline
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        align: "center",
        margin: "0 5px 0 0"
      }, product.meta.policyNumbers.secondary.label[_this.props.member.language], ":"), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        bold: true,
        align: "center"
      }, product.meta.secondaryPolicyNumber || '-'))) : /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          flex: 2
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        align: "center"
      }, "-")), product.meta.coverageSummary ? /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          flex: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.inline
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        color: _this.props.whitelabel.primaryColor || _theme.colors.skyBlue,
        onClick: function onClick() {
          return window.open(product.meta.coverageSummary.primary.link, "_blank");
        },
        customStyle: {
          flex: 1,
          cursor: 'pointer'
        },
        align: "center"
      }, product.meta.coverageSummary.primary.label[_this.props.member.language])), product.meta.coverageSummary.secondary && /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.inline
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        color: _this.props.whitelabel.primaryColor || _theme.colors.skyBlue,
        onClick: function onClick() {
          return window.open(product.meta.coverageSummary.secondary.link, "_blank");
        },
        customStyle: {
          flex: 1,
          cursor: 'pointer'
        },
        align: "center"
      }, product.meta.coverageSummary.secondary.label[_this.props.member.language]))) : /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        customStyle: {
          flex: 2
        },
        align: "center"
      }, product.meta.pricingType === 'static' ? '-' : _i18n["default"].t(_tokens["default"].labels.marketplace.pricingInCoverage, {
        pricing: _sbUtils.helpers.formatNumber(product.primary.volume, 2, true)
      })), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        customStyle: {
          flex: 1
        },
        align: "center"
      }, "".concat(_sbUtils.helpers.formatNumber(product.primary.premium + product.primary.PST + (product.primary.RST || 0) + product.primary.GST + product.primary.HST, 2, true)).concat(_i18n["default"].t(_tokens["default"].labels.marketplace.perMonth))), /*#__PURE__*/_react["default"].createElement("span", {
        style: styles.iconBlock
      }, /*#__PURE__*/_react["default"].createElement(_MoreVert["default"], {
        style: styles.moreIcon,
        onClick: function onClick(e) {
          return _this._handleMenuClick(e, product.primary.productID, null, 'primary');
        }
      }))), product.dependent && /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.blockRow
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          flex: 3,
          paddingLeft: 10
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        mediumLarge: true
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.dependentCoverage)), product.dependent.termDate && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        tiny: true,
        color: "red"
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.terminateOnDate, {
        termDate: dates.formatDateForDisplay(product.dependent.termDate)
      }))), product.meta.policyNumbers ? /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          flex: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.inline
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        align: "center",
        margin: "0 5px 0 0"
      }, _i18n["default"].t(_tokens["default"].labels.claimSummary.primary), ":"), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        bold: true,
        align: "center"
      }, product.meta.primaryPolicyNumber || '-')), product.meta.policyNumbers.secondary && /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.inline
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        align: "center",
        margin: "0 5px 0 0"
      }, product.meta.policyNumbers.secondary.label[_this.props.member.language], ":"), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        bold: true,
        align: "center"
      }, product.meta.secondaryPolicyNumber))) : /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          flex: 2
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        align: "center"
      }, "-")), product.meta.coverageSummary ? /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          flex: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.inline
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        color: _this.props.whitelabel.primaryColor || _theme.colors.skyBlue,
        onClick: function onClick() {
          return window.open(product.meta.coverageSummary.primary.link, "_blank");
        },
        customStyle: {
          flex: 1,
          cursor: 'pointer'
        },
        align: "center"
      }, product.meta.coverageSummary.primary.label[_this.props.member.language])), product.meta.coverageSummary.secondary && /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.inline
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        color: _this.props.whitelabel.primaryColor || _theme.colors.skyBlue,
        onClick: function onClick() {
          return window.open(product.meta.coverageSummary.secondary.link, "_blank");
        },
        customStyle: {
          flex: 1,
          cursor: 'pointer'
        },
        align: "center"
      }, product.meta.coverageSummary.secondary.label[_this.props.member.language]))) : /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        customStyle: {
          flex: 2
        },
        align: "center"
      }, product.meta.pricingType === 'static' ? '-' : _i18n["default"].t(_tokens["default"].labels.marketplace.pricingInCoverage, {
        pricing: _sbUtils.helpers.formatNumber(product.dependent.volume, 2, true)
      })), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        customStyle: {
          flex: 1
        },
        align: "center"
      }, "".concat(_sbUtils.helpers.formatNumber(product.dependent.premium + product.dependent.PST + (product.dependent.RST || 0) + product.dependent.GST + product.dependent.HST, 2, true)).concat(_i18n["default"].t(_tokens["default"].labels.marketplace.perMonth))), /*#__PURE__*/_react["default"].createElement("span", {
        style: styles.iconBlock
      }, /*#__PURE__*/_react["default"].createElement(_MoreVert["default"], {
        style: styles.moreIcon,
        onClick: function onClick(e) {
          return _this._handleMenuClick(e, product.dependent.productID, product.primary.productID, 'primary');
        }
      }))), product.spouse && /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.blockRow
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          flex: 3,
          paddingLeft: 10
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        mediumLarge: true
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.spouseCoverage)), product.spouse.termDate && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        tiny: true,
        color: "red"
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.terminateOnDate, {
        termDate: dates.formatDateForDisplay(product.spouse.termDate)
      }))), product.meta.policyNumbers ? /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          flex: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.inline
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        align: "center",
        margin: "0 5px 0 0"
      }, _i18n["default"].t(_tokens["default"].labels.claimSummary.primary), ":"), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        bold: true,
        align: "center"
      }, product.meta.primaryPolicyNumber || '-')), product.meta.policyNumbers.secondary && /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.inline
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        align: "center",
        margin: "0 5px 0 0"
      }, product.meta.policyNumbers.secondary.label[_this.props.member.language], ":"), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        bold: true,
        align: "center"
      }, product.meta.secondaryPolicyNumber))) : /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          flex: 2
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        align: "center"
      }, "-")), product.meta.coverageSummary ? /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          flex: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.inline
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        color: _this.props.whitelabel.primaryColor || _theme.colors.skyBlue,
        onClick: function onClick() {
          return window.open(product.meta.coverageSummary.primary.link, "_blank");
        },
        customStyle: {
          flex: 1,
          cursor: 'pointer'
        },
        align: "center"
      }, product.meta.coverageSummary.primary.label[_this.props.member.language])), product.meta.coverageSummary.secondary && /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.inline
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        color: _this.props.whitelabel.primaryColor || _theme.colors.skyBlue,
        onClick: function onClick() {
          return window.open(product.meta.coverageSummary.secondary.link, "_blank");
        },
        customStyle: {
          flex: 1,
          cursor: 'pointer'
        },
        align: "center"
      }, product.meta.coverageSummary.secondary.label[_this.props.member.language]))) : /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        customStyle: {
          flex: 2
        },
        align: "center"
      }, product.meta.pricingType === 'static' ? '-' : _i18n["default"].t(_tokens["default"].labels.marketplace.pricingInCoverage, {
        pricing: _sbUtils.helpers.formatNumber(product.spouse.volume, 2, true)
      })), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        customStyle: {
          flex: 1
        },
        align: "center"
      }, "".concat(_sbUtils.helpers.formatNumber(product.spouse.premium + product.spouse.PST + (product.spouse.RST || 0) + product.spouse.GST + product.spouse.HST, 2, true)).concat(_i18n["default"].t(_tokens["default"].labels.marketplace.perMonth))), /*#__PURE__*/_react["default"].createElement("span", {
        style: styles.iconBlock
      }, /*#__PURE__*/_react["default"].createElement(_MoreVert["default"], {
        style: styles.moreIcon,
        onClick: function onClick(e) {
          return _this._handleMenuClick(e, product.spouse.productID, product.primary.productID, 'primary');
        }
      }))), product.child && /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.blockRow
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          flex: 3,
          paddingLeft: 10
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        mediumLarge: true
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.childCoverage)), product.child.termDate && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        tiny: true,
        color: "red"
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.terminateOnDate, {
        termDate: dates.formatDateForDisplay(product.child.termDate)
      }))), product.meta.policyNumbers ? /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          flex: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.inline
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        align: "center",
        margin: "0 5px 0 0"
      }, _i18n["default"].t(_tokens["default"].labels.claimSummary.primary), ":"), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        bold: true,
        align: "center"
      }, product.meta.primaryPolicyNumber || '-')), product.meta.policyNumbers.secondary && /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.inline
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        align: "center",
        margin: "0 5px 0 0"
      }, product.meta.policyNumbers.secondary.label[_this.props.member.language], ":"), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        bold: true,
        align: "center"
      }, product.meta.secondaryPolicyNumber))) : /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          flex: 2
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        align: "center"
      }, "-")), product.meta.coverageSummary ? /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          flex: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.inline
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        color: _this.props.whitelabel.primaryColor || _theme.colors.skyBlue,
        onClick: function onClick() {
          return window.open(product.meta.coverageSummary.primary.link, "_blank");
        },
        customStyle: {
          flex: 1,
          cursor: 'pointer'
        },
        align: "center"
      }, product.meta.coverageSummary.primary.label[_this.props.member.language])), product.meta.coverageSummary.secondary && /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.inline
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        color: _this.props.whitelabel.primaryColor || _theme.colors.skyBlue,
        onClick: function onClick() {
          return window.open(product.meta.coverageSummary.secondary.link, "_blank");
        },
        customStyle: {
          flex: 1,
          cursor: 'pointer'
        },
        align: "center"
      }, product.meta.coverageSummary.secondary.label[_this.props.member.language]))) : /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        customStyle: {
          flex: 2
        },
        align: "center"
      }, product.meta.pricingType === 'static' ? '-' : _i18n["default"].t(_tokens["default"].labels.marketplace.pricingInCoverage, {
        pricing: _sbUtils.helpers.formatNumber(product.child.volume, 2, true)
      })), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        customStyle: {
          flex: 1
        },
        align: "center"
      }, "".concat(_sbUtils.helpers.formatNumber(product.child.premium + product.child.PST + (product.child.RST || 0) + product.child.GST + product.child.HST, 2, true)).concat(_i18n["default"].t(_tokens["default"].labels.marketplace.perMonth))), /*#__PURE__*/_react["default"].createElement("span", {
        style: styles.iconBlock
      }, /*#__PURE__*/_react["default"].createElement(_MoreVert["default"], {
        style: styles.moreIcon,
        onClick: function onClick(e) {
          return _this._handleMenuClick(e, product.child.productID, product.primary.productID, 'primary');
        }
      }))));
    }, (0, _assertThisInitialized2["default"])(_this)));
  }
  /**
   * @param event
   * @param productID
   * @param parentProductID
   * @param entity
   * @private
   */
  /**
   * @param signage
   * @param password
   * @returns {Promise<boolean>}
   * @private
   */
  (0, _createClass2["default"])(PurchasedProducts, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var styles = {
        container: {
          display: 'flex',
          flex: 1,
          flexDirection: 'column'
        },
        titleBlock: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          marginBottom: 10
        },
        block: {
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          border: "1px solid ".concat(_theme.colors.lightGrey),
          backgroundColor: _theme.colors.surface,
          position: 'relative',
          zIndex: _zIndex["default"].container
        },
        blockTitle: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          padding: "20px 30px",
          borderBottom: "1px solid ".concat(_theme.colors.lightGrey)
        },
        blockContent: {
          display: 'flex',
          flexDirection: 'column',
          padding: "20px 30px",
          borderBottom: "1px solid ".concat(_theme.colors.lightGrey)
        },
        blockRow: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          padding: "10px 0 0 0"
        },
        totalBlock: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          padding: "20px 30px"
        },
        iconBlock: {
          textAlign: 'right',
          width: 20
        },
        moreIcon: {
          color: _theme.colors.darkGrey,
          cursor: 'pointer'
        },
        inline: {
          display: 'flex',
          flex: 1,
          flexDirection: 'row',
          alignItems: 'center'
        }
      };
      var purchasedProducts = Object.keys(this.props.purchasedProducts);
      var productNameToTerminate = null;
      var productToTerminate = null;
      if (this.state.showTerminationModal) {
        productToTerminate = this.props.purchasedProducts[this.state.productToTerminate.parentProductID || this.state.productToTerminate.productID].meta;
        if (productToTerminate.childProductType && productToTerminate.childProductType.toLowerCase() !== 'primary') {
          productNameToTerminate = productToTerminate.name.child;
        } else {
          productNameToTerminate = productToTerminate.name.primary;
        }
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.titleBlock
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        large: true,
        bold: true,
        margin: "0 0 10px 0"
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.yourProducts))), purchasedProducts.length === 0 ? /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.block
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.blockTitle
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.noProductsPurchased)))) : /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.block
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.blockTitle
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        mediumLarge: true,
        bold: true,
        customStyle: {
          flex: 3
        }
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.marketplaceProduct)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        mediumLarge: true,
        bold: true,
        customStyle: {
          flex: 2
        },
        align: "center"
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.primaryPolicyNumber)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        mediumLarge: true,
        bold: true,
        customStyle: {
          flex: 2
        },
        align: "center"
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.coverage)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        mediumLarge: true,
        bold: true,
        align: "center",
        customStyle: {
          flex: 1
        }
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.monthlyFee)), /*#__PURE__*/_react["default"].createElement("span", {
        style: styles.iconBlock
      })), purchasedProducts.length > 0 && purchasedProducts.map(function (productID) {
        var product = _this2.props.purchasedProducts[productID];
        return _this2._renderRow(styles, product, _this2.props.member);
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.totalBlock
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        large: true,
        bold: true,
        customStyle: {
          flex: 1
        }
      }, _i18n["default"].t(_tokens["default"].labels.total)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        large: true,
        bold: true
      }, _sbUtils.helpers.formatNumber(this._getTotal(), 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        customStyle: {
          marginTop: 5
        }
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.perMonth))), this.state.showTerminationModal && /*#__PURE__*/_react["default"].createElement(_TerminationModal["default"], {
        close: this._closeTerminationModal,
        save: this._terminateProduct,
        loading: this.props.loading,
        isMasterSite: this.props.isMasterSite,
        whitelabel: this.props.whitelabel,
        productToTerminate: productToTerminate,
        member: this.props.member
      }), /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
        anchorEl: this.state.anchorEl,
        open: this.state.anchorEl !== null,
        onClose: this._handleCloseMenu,
        disableAutoFocusItem: true,
        sx: {
          '& .MuiPaper-root': {
            borderRadius: '8px',
            minWidth: 250
          }
        },
        anchorOrigin: {
          vertical: "top",
          horizontal: "left"
        }
      }, /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        style: styles.navDropMenuItem,
        onClick: this._openTerminationModal
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        align: "center",
        medium: true,
        display: "block",
        customLinkStyle: {
          textDecoration: 'none'
        }
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.terminateCoverage))))));
    }
  }]);
  return PurchasedProducts;
}(_react.PureComponent);
var _default = exports["default"] = PurchasedProducts;